import { PersonTypes } from '@frontend/api-person';
import { InsuranceContainer } from './insurance-container';
import { InsuranceProvider } from './providers/insurance-provider';
import { InsuranceTypeProvider } from './providers/insurance-type-provider';
import { PersonInfoStoreProvider } from './providers/person-info-provider';
import { UndefinedOrNull } from './utils/types';

interface Props {
  locationId: string;
  personInfo: UndefinedOrNull<PersonTypes.Person>;
}

export const InsuranceTab = ({ locationId, personInfo }: Props) => {
  return (
    <PersonInfoStoreProvider personInfo={personInfo as PersonTypes.Person} locationId={locationId}>
      <InsuranceTypeProvider>
        <InsuranceProvider personInfo={personInfo as PersonTypes.Person} locationId={locationId}>
          <InsuranceContainer />
        </InsuranceProvider>
      </InsuranceTypeProvider>
    </PersonInfoStoreProvider>
  );
};
InsuranceTab.displayName = 'InsuranceTab';
